import { dew as _indexDew } from "../index.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.formatProof = void 0;
  const index_js_1 = _indexDew();
  function formatStorageProof(storageProof) {
    return storageProof.map(proof => ({
      ...proof,
      value: BigInt(proof.value)
    }));
  }
  function formatProof(proof) {
    return {
      ...proof,
      balance: proof.balance ? BigInt(proof.balance) : undefined,
      nonce: proof.nonce ? (0, index_js_1.hexToNumber)(proof.nonce) : undefined,
      storageProof: proof.storageProof ? formatStorageProof(proof.storageProof) : undefined
    };
  }
  exports.formatProof = formatProof;
  //# sourceMappingURL=proof.js.map
  return exports;
}